import { Airror } from '@air/errors';

// biome-ignore lint/suspicious/noExplicitAny: <https://linear.app/air/issue/ENG-136/update-isairrorinstance-to-not-use-any>
export function isAirrorInstance(result: any): result is Airror<any, any> {
  return result instanceof Airror;
}
